var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Model } from 'vue-property-decorator';
import DataBox from '~/components/common/data-box.vue';
import { PrincipalService } from "~/services/domain-service/principal.service";
import { DepartmentService } from "~/services/management-service/department.service";
import { Dependencies } from "~/core/decorator";
var CommissionSet = /** @class */ (function (_super) {
    __extends(CommissionSet, _super);
    function CommissionSet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommissionSet.prototype.deleteClick = function (scope) {
        if (scope.row.id) {
            this.isOrganize ? this.deleteOrganize(scope) : this.deleteAccount(scope);
        }
        else {
            this.dataSet.splice(scope.$index, 1);
        }
    };
    CommissionSet.prototype.deleteOrganize = function (scope) {
        var _this = this;
        this.departmentService.deletePerformanceDetailById(scope.row.id).subscribe(function (data) {
            _this.dataSet.splice(scope.$index, 1);
        });
    };
    CommissionSet.prototype.deleteAccount = function (scope) {
        var _this = this;
        this.principalService.deleteCommissionDetailById(scope.row.id).subscribe(function (data) {
            _this.dataSet.splice(scope.$index, 1);
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    __decorate([
        Model('change')
    ], CommissionSet.prototype, "dataSet", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], CommissionSet.prototype, "isCommission", void 0);
    __decorate([
        Prop({ default: false })
    ], CommissionSet.prototype, "isOrganize", void 0);
    __decorate([
        Dependencies(PrincipalService)
    ], CommissionSet.prototype, "principalService", void 0);
    __decorate([
        Dependencies(DepartmentService)
    ], CommissionSet.prototype, "departmentService", void 0);
    CommissionSet = __decorate([
        Component({
            components: {
                DataBox: DataBox
            }
        })
    ], CommissionSet);
    return CommissionSet;
}(Vue));
export default CommissionSet;
